
import './App.css';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import Alert from  'react-bootstrap/Alert';
import { AppContext } from './context/app';
import { useContext, useEffect, useState } from 'react';

import awsExports from "./aws-exports";
import Amplify  from 'aws-amplify';

import { AmplifySignIn , AmplifyAuthenticator, AmplifySignOut, AmplifyForgotPassword, AmplifyVerifyContact, AmplifyRequireNewPassword} from '@aws-amplify/ui-react';
import Clubs from './Components/Clubs';
import { Athletes } from './Components/Athletes';
import { Coaches } from './Components/Coaches';
import { Users } from './Components/Users';
import { isMemberOf } from './common/variables';
import { Profile } from './Components/Profile';
import { ClubProfile } from './Components/ClubProfile';
import { AthleteDetails } from './Components/AthleteDetails';
import { CoachContext } from './context/coach';

Amplify.configure(awsExports);

function AppNav(){
  const { appState , resetState } = useContext(AppContext);
  const { user } = appState;
  return(
    <Navbar bg="primary" variant="light" style={{display : 'grid' , gridTemplateColumns : '1fr 1fr'}}>
      <Navbar.Brand href="/" className="d-flex">
        <img alt="" src="AABLogo.png" width="30" height="30" className="align-top"/>
        <p className="mb-0">AAB Portal</p>
      </Navbar.Brand>
      <Nav style={{justifySelf : "end"}}>
        <NavDropdown title={`${user.email}`} className="text-muted  font-italic font-weight-bolder" style={{padding : "0.5rem" , fontSize : "15px"}}>
            <AmplifySignOut handleAuthStateChange={(nextState)=>{
              if(nextState === "signedout"){
                resetState();
              }
            }}/>
        </NavDropdown>
      </Nav>
    </Navbar>
  )
}
function SideBar(){
  const { appState : {user : { groups}}} = useContext(AppContext);
  const { setCurrentView } = useContext(AppContext);
  const [activeKey , setActiveKey] = useState('#athletes');
  function handleKeySelect(key){
    setActiveKey(key);
    setCurrentView(key);
  }
  return(
    <div className="p-2 border-right" style={{backgroundColor: '#007bff33'}}>
      <Nav style={{width : "80%"}} variant="pills" activeKey={activeKey} onSelect={handleKeySelect}>
        {(isMemberOf(groups,'athlete') || isMemberOf(groups,'coach'))  && <Nav.Link href="#myprofile" eventKey="#myprofile">My Profile</Nav.Link>}
        {(isMemberOf(groups,'athlete') || isMemberOf(groups,'coach'))  && <Nav.Link href="#myclub" eventKey="#myclub">My Club</Nav.Link>}
        {!(isMemberOf(groups,'athlete') || isMemberOf(groups,'coach')) && <Nav.Link href="#athletes" eventKey="#athletes">Athletes</Nav.Link>}
        {!(isMemberOf(groups,'athlete') || isMemberOf(groups,'coach')) && <Nav.Link href="#coaches" eventKey="#coaches">Coaches</Nav.Link>}
        {isMemberOf(groups,'admin') && <Nav.Link href="#clubs" eventKey="#clubs">Clubs</Nav.Link>}
        {isMemberOf(groups , 'admin') && <Nav.Link  href="#users" eventKey="#users">Manager Users</Nav.Link>}
      </Nav>
    </div>
  )
}
function App() {
  const { appState , getUser } = useContext(AppContext);
  const { SetCoachProfile } = useContext(CoachContext);
  const {currentView , toastMessage , showToast , messageType , get} = appState;
  const [userToVerify , setUserToVerify] = useState(null);
  const [userToReset , setUserToReset] = useState(null);
  const [authState, setAuthState] = useState("not_signedin");
  const { user : { groups }} = appState;
  useEffect(()=>{
    try{
      getUser();
    }
    catch(err){
      console.log(err)
    }
  },[])
  useEffect(()=>{
    try{
      if(isMemberOf(groups , 'coach')){
        SetCoachProfile();
      }
      if(isMemberOf(groups , 'athlete')){
        
      }
    }
    finally{
    }
  },[groups])
  async function handleSignIn(state, data){
    setAuthState(state)
    if(state === "verifyContact"){
      setUserToVerify(data);
    }
    if(state === "resettingpassword"){
      setUserToReset(data);
    }
    if(state === "signedin"){
      await getUser();
      setUserToVerify(null);
    }
  }
  function LandingPage(){
    return(
          <div className="mr-2 p-2">
            <h3>Welcome to Athletics Association of Barbados management portal.</h3>
          </div>
    )
  }
  return (
    <Container fluid className="p-0 d-flex flex-column">
      <AmplifyAuthenticator handleAuthStateChange={handleSignIn}>
          <AmplifySignIn headerText="Sign in to AAB Portal" slot="sign-in" hideSignUp />
          {authState === "verifyContact" && <AmplifyVerifyContact slot="verify-contact" user={userToVerify}/>}
          {/* { authState == "resettingpassword" && <AmplifyRequireNewPassword slot="require-new-password" user={userToReset}/>} */}
          { authState === "forgotpassword" && <AmplifyForgotPassword slot="forgot-password"/>}
          {
            authState === "signedin" &&
            <>
            <AppNav/>
            <div className="p-2">
              <SideBar/>
              {
                currentView === "#myprofile" ? <Profile/> : 
                currentView === "#myclub" ? <ClubProfile/> : 
                currentView === "#athletes" ? <Athletes/> : 
                currentView === "#clubs" ? <Clubs/> : 
                currentView === "#coaches" ? <Coaches/> : 
                currentView === "#users" ? <Users/> : 
                currentView.startsWith('#athleteDetails') ? <AthleteDetails/> : 
                <LandingPage />
              }
            </div>
            </>
          }          
        <Alert show={showToast} variant={messageType} dismissible style={{position : "absolute" , bottom : "10px" , left : "50%" }}>
            {toastMessage}
        </Alert>
          </AmplifyAuthenticator>
    </Container>
  );
}

export default App;
